<template>
  <g :class="['pf-annotation-position__tag']">
    <rect
      :stroke="fill"
      :stroke-width="2"
      :fill="fill"
      :x="tagX"
      :y="tagY"
      :width="width"
      :height="height"
    />
    <text fill="white" :x="textX" :y="textY">{{ text }}</text>
  </g>
</template>

<script>
  export default {
    name: 'PfPositionTag',
    props: {
      tagX: {
        type: Number,
        required: true,
      },
      tagY: {
        type: Number,
        required: true,
      },
      width: {
        type: Number,
        default: 90,
      },
      height: {
        type: Number,
        default: 22,
      },
      textX: {
        type: Number,
      },
      textY: {
        type: Number,
      },
      text: {
        type: [Number, String],
      },
    },
    data() {
      return {
        fill: '#333333',
      };
    },
  };
</script>

<style lang="scss">
  @import '@mce/visual-language';
  @import '@mds/constants';

  .pf-annotation-position {
    &__tag {
      cursor: grab;
    }
  }
</style>
